export default {
	TITLE: 'Ingredient component translations',
	BATCH_ADD: 'Click to add',

	MODAL_TITLE: 'Add ingredient component translations',
	NAME: 'Name',
	NAME_PLACEHOLDER: 'Enter name...',
	LANGUAGE: 'Language',
	LANGUAGE_PLACEHOLDER: 'Select language...',
	SUBMIT: 'Submit',
	ADD_ROW_TOOLTIP: 'Add row',
};
